import { FC } from 'react';
import { Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { IVanHost } from 'src/store/reducers/host/types';
import './styles.scss';

interface IProps {
  host: IVanHost;
}

const HostCard: FC<IProps> = ({ host }) => {
  return (
    <div className='host-card'>
      <div className='client__order__main__header'>
        <h4>Hosted by</h4>
        <div className='host-card__phone'>TEXT/CALL: {host.phone}</div>
      </div>
      <div className='host-card__container'>
        <Avatar
          alt='user photo'
          src={host.photo ?? '/broken-image.jpg'}
          sx={{ width: '80px', height: '80px' }}
        />
        <div className='host-card__main-info'>
          <div className='host-card__main-info__name'>{host.first_name}</div>
          <div className='host-card__main-info__wrapper'>
            <span className='host-card__main-info__rating'>4.9</span>
            <StarIcon />
            <span className='host-card__main-info__reviews'>Lots of reviews</span>
          </div>
        </div>
      </div>
      <p className='host-card__joined'>Joined Feb 2020</p>
      <div className='host-card__verified'>
        <img src='../images/shield-tick.png' alt='verified' />
        <span>Identity verified</span>
      </div>
    </div>
  );
};

export default HostCard;
